var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.632608 12C0.670107 12 0.707608 11.9963 0.745108 11.9906L3.89886 11.4375C3.93636 11.43 3.97198 11.4131 3.99823 11.385L11.9464 3.43687C11.9637 3.41953 11.9775 3.39892 11.9869 3.37624C11.9963 3.35356 12.0012 3.32924 12.0012 3.30469C12.0012 3.28013 11.9963 3.25582 11.9869 3.23313C11.9775 3.21045 11.9637 3.18985 11.9464 3.1725L8.83011 0.054375C8.79448 0.01875 8.74761 0 8.69698 0C8.64636 0 8.59948 0.01875 8.56386 0.054375L0.615732 8.0025C0.587607 8.03062 0.570732 8.06437 0.563232 8.10187L0.0101073 11.2556C-0.00813296 11.3561 -0.00161553 11.4594 0.0290952 11.5568C0.059806 11.6542 0.113784 11.7426 0.186357 11.8144C0.310107 11.9344 0.465732 12 0.632608 12ZM1.89636 8.73L8.69698 1.93125L10.0714 3.30562L3.27073 10.1044L1.60386 10.3988L1.89636 8.73Z",
    fill: "#262641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6ba5e4bb200a9fbcafc4fb24761f5d02.svg";
export { ForwardRef as ReactComponent };